import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

const ConfirmationMilitaryRetiredPayWaiver = ({ formData }) => {
  const waiving =
    formData?.servicePay?.isWaivingVaBenefitsForMilitaryRetiredPay;
  if (typeof waiving !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Military retired pay waiver"
      rows={[
        {
          label: 'Do you want to receive VA disability compensation?',
          value: waiving
            ? 'No, I don’t want to receive VA disability compensation.'
            : 'Yes, I want to receive VA disability compensation.',
        },
      ]}
    />
  );
};

ConfirmationMilitaryRetiredPayWaiver.propTypes = {
  formData: PropTypes.shape({
    servicePay: PropTypes.shape({
      isWaivingVaBenefitsForMilitaryRetiredPay: PropTypes.bool,
    }),
  }),
};

export default ConfirmationMilitaryRetiredPayWaiver;
